export default __webpack_public_path__ + "static/media/bg-back.57589468.png";